<template>
  <div class="section-sign-up-team" id="section-sign-up-team">
    <form-dynamix type="team" :feedback="feedback" :loading="loading"
      :names="names" :models="models" :attributes="attributes"
      :vuelidate="$v"
      :is-print="isPrint"
      :is-print-pdf="isPrintPdf"
      @recaptcha="onRecaptcha"
      @send="onSend">
    </form-dynamix>
    <b-modal class="modal-wrapper" scroll="keep" :active.sync="isMapModalActive" style="width:100%;height:100%;">
      <div style="background-color:white;padding:12px 8px 3px 8px;font-weight:bold;font-size:0.9em;">
        <span v-if="markerCurrent !== undefined">
          Choose {{ markerCurrent.attributes.title }} desired location.
        </span>
        <span v-else>
          Choose all five desired locations.
        </span>
      </div>
      <p class="image is-4by3" style="width:100%;height:100%;position:relative;background-color:white;margin-bottom:0;">
        <img v-if="isDesktop" src="../assets/map.png" ref="mapRef" style="max-width:100%;max-height:100%;height:auto;display:inline-block;" />
        <a v-else :href="imageMapSrc" target="_blank">
          <img src="../assets/map.png" ref="mapRef" style="max-width:100%;max-height:100%;display:inline-block;" />
        </a>
        <div v-if="!isDesktop" style="text-align:center;background-color:white;">
          (click to open map in a new tab)
        </div>
        <div v-if="isDesktop" v-for="marker in markerList" :key="marker.text" class="marker" :class="{ 'disabled': marker.state === 0, 'enabled': marker.state === 1, 'selected': marker.state === 2 }" :style="{ top: marker.top, left: marker.left, height: markerHeight }" @click="onClickMapMarker(marker)">
          {{ marker.text }}
          <div v-if="isDesktop" style="position:absolute;z-index:99999;background-color:rgba(255,255,255,0.5);font-size:0.8em;font-weight:bold;" :style="{ top: marker.selTop, bottom: marker.selBottom, left: marker.selLeft, right: marker.selRight }">
            {{ marker.textSelected }}
          </div>
        </div>
        <div v-if="false && isDesktop && markerCurrent === undefined" class="marker" style="position:absolute;padding-left:8px;padding-right:8px;background-color:rgba(255,255,255,0.5);" :style="{ top: markerClear.top, left: markerClear.left, height: markerHeight, width: 'auto' }" @click="onResetMapMarker()">
          Reset All Locations
        </div>
      </p>

      <div v-if="!isDesktop" class="columns is-multiline is-mobile is-centered is-gapless" style="text-align:center;background-color:rgba(255,255,255,0.5);margin-bottom:0;">
        <div v-for="marker in markerList" :key="marker.text" class="column is-narrow">
          <div class="marker static" :class="{ 'disabled': marker.state === 0, 'enabled': marker.state === 1, 'selected': marker.state === 2 }" style="display:inline-block;margin:3px auto;padding:3px 15px;text-align:center;" @click="onClickMapMarker(marker)">
            {{ marker.text }}
            <div style="font-size:0.7em;font-weight:bold;">
              {{ marker.textSelected }}
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-multiline is-mobile is-centered is-gapless" style="text-align:center;background-color:white;">
        <div v-if="markerCurrent === undefined" class="column is-6">
          <div class="marker static" style="display:inline-block;margin:5px auto 18px auto;padding:5px 12px;text-align:center;background-color:rgba(255,255,255,0.5);" @click="onResetMapMarker()">
            Reset All Locations
          </div>
        </div>
        <div class="column is-6">
          <div class="marker static"  style="display:inline-block;margin:5px auto 18px auto;padding:5px 12px;text-align:center;background-color:rgba(10,30,200,0.5);color:white;" @click="onProceed()">
            Proceed
          </div>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script type="text/javascript">
import _ from 'lodash'
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
import FormDynamix from '@/components/FormDynamix'
import { validationMixin } from 'vuelidate'
import { required, numeric, email, between, minLength, maxLength } from 'vuelidate/lib/validators'
import Site from '@/apis/Site'
import moment from 'moment'
import imageMap from '@/assets/map.png'

// function validateArrayRequired (values) {
//   if (values && values.length > 0) {
//     var isChecked = false
//     for (var i = 0; i < values.length; i++) {
//       var value = values[i]
//       isChecked |= value
//     }
//     return isChecked
//   }
//   return false
// }
//
// function validateArrayOneNoneOrTwoThreeFour (values) {
//   if (values && values.length > 0) {
//     var noneSelected = false
//     var eitherOneSelected = false
//     if (values[1] === true) {
//       noneSelected = true
//     }
//     if (values[2] === true) {
//       eitherOneSelected = true
//     }
//     if (values[3] === true) {
//       eitherOneSelected = true
//     }
//     if (values[4] === true) {
//       eitherOneSelected = true
//     }
//     if (noneSelected && eitherOneSelected) {
//       return false
//     }
//   }
//   return true
// }

function validateEitherOr (value1, value2) {
  // console.log('-- validate either or --')
  // console.log(value1)
  // console.log(value2)
  if (value1 && !value2) {
    return true
  } else if (!value1 && value2) {
    return true
  }
  return false
}

function validateUnique (valueOwn, value2, value3, value4, value5) {
  var values = []
  if (valueOwn) { values.push(valueOwn) }
  if (value2) { values.push(value2) }
  if (value3) { values.push(value3) }
  if (value4) { values.push(value4) }
  if (value5) { values.push(value5) }

  for (var i = 0; i < (values.length > 0 ? 1 : 0); i++) {
    for (var j = 0; j < values.length; j++) {
      if (i !== j) { // do not check itself
        if (values[i] === values[j]) {
          return false
        }
      }
    }
  }
  return true
}

function addAllValues (value1, value2, value3, value4, value5, value6) {
  var values = 0
  if (value1 && parseInt(value1, 10)) {
    values += parseInt(value1, 10)
  }
  if (value2 && parseInt(value2, 10)) {
    values += parseInt(value2, 10)
  }
  if (value3 && parseInt(value3, 10)) {
    values += parseInt(value3, 10)
  }
  if (value4 && parseInt(value4, 10)) {
    values += parseInt(value4, 10)
  }
  if (value5 && parseInt(value5, 10)) {
    values += parseInt(value5, 10)
  }
  if (value6 && parseInt(value6, 10)) {
    values += parseInt(value6, 10)
  }
  return values
}

export default {
  name: 'section-sign-up-team',
  mixins: [validationMixin],
  components: {
    DivContainer,
    DivColumns,
    PageSubheader,
    FormDynamix
  },
  props: ['is-print'],
  watch: {
    'isPrint': {
      handler: function (value, oldValue) {
        var isPrint = value
        if (isPrint) {
          this.attributes.topMap.column = 'is-10'
        } else {
          this.attributes.topMap.column = 'is-5'
        }

        if (isPrint) {
          this.models.signAt = ''
        } else {
          this.models.signAt = (moment(new Date())).format()
        }
      }
    },
    'models.competition': {
      handler: function (value, oldValue) {
        var disabled = (value !== 1)
        this.attributes.top1.disabled = disabled
        this.attributes.top2.disabled = disabled
        this.attributes.top3.disabled = disabled
        this.attributes.top4.disabled = disabled
        this.attributes.top5.disabled = disabled
        this.attributes.volunteer.disabled = disabled
        if (disabled) {
          this.models.top1 = ''
          this.models.top2 = ''
          this.models.top3 = ''
          this.models.top4 = ''
          this.models.top5 = ''
          this.models.volunteer = undefined
        }
        // if (value[2] !== oldValue[2]) {
        // var changed = value.filter(function (p, idx) {
        //   return Object.keys(p).some(function (prop) {
        //     return p[prop] !== oldValue[idx][prop]
        //   })
        // })
        // console.log('changed-value...')
        // console.log(changed)

        if (value !== oldValue && value === 1) {
          this.models.competition2 = false
        }
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      },
      deep: true
    },
    'models.competition2': {
      handler: function (value, oldValue) {
        if (value !== oldValue && value === 2) {
          this.models.competition = false
        }
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    },
    'models.members': {
      handler: function (value, oldValue) {
        console.log('member change: ' + value)
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    },
    'models.tshirt': {
      handler: function (value, oldValue) {
        var disabled = (value !== 1)
        this.attributes.tshirtS.disabled = disabled
        this.attributes.tshirtM.disabled = disabled
        this.attributes.tshirtL.disabled = disabled
        this.attributes.tshirtXL.disabled = disabled
        this.attributes.tshirt2XL.disabled = disabled
        this.attributes.tshirt3XL.disabled = disabled
        if (disabled) {
          this.models.tshirtS = ''
          this.models.tshirtM = ''
          this.models.tshirtL = ''
          this.models.tshirtXL = ''
          this.models.tshirt2XL = ''
          this.models.tshirt3XL = ''
        }
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      },
      deep: true
    },
    'models.tshirtS': {
      handler: function (value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    },
    'models.tshirtM': {
      handler: function (value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    },
    'models.tshirtL': {
      handler: function (value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    },
    'models.tshirtXL': {
      handler: function (value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    },
    'models.tshirt2XL': {
      handler: function (value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    },
    'models.tshirt3XL': {
      handler: function (value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL)
      }
    }
  },
  computed: {
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  data: function () {
    return {
      isDesktop: true,
      isIE: EventBus.detectIE(),
      isPrintPdf: '/static/team-application.pdf',
      isMapModalActive: false,
      imageMapSrc: imageMap,
      markerCurrent: undefined,
      markerHeight: '4%',
      markerClear: {
        topRatio: 57,
        top: '57%',
        left: '2%'
      },
      markerList: [{
        text: '1',
        textSelected: '',
        topRatio: 5.8,
        top: '5.8%',
        left: '14%',
        state: 0,
        selTop: 'initial',
        selBottom: '50%',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '2',
        textSelected: '',
        topRatio: 8.8,
        top: '8.8%',
        left: '11%',
        state: 0,
        selTop: 'initial',
        selBottom: '50%',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '3',
        textSelected: '',
        topRatio: 12.4,
        top: '12.4%',
        left: '8%',
        state: 0,
        selTop: 'initial',
        selBottom: '50%',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '4',
        textSelected: '',
        topRatio: 15.8,
        top: '15.8%',
        left: '6.3%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '5',
        textSelected: '',
        topRatio: 20.2,
        top: '20.2%',
        left: '5.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '6',
        textSelected: '',
        topRatio: 24.6,
        top: '24.6%',
        left: '5.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '7',
        textSelected: '',
        topRatio: 28.6,
        top: '28.6%',
        left: '5.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '8',
        textSelected: '',
        topRatio: 33,
        top: '33%',
        left: '6.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '9',
        textSelected: '',
        topRatio: 36.9,
        top: '36.9%',
        left: '9%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '10',
        textSelected: '',
        topRatio: 40.4,
        top: '40.4%',
        left: '12%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '11',
        textSelected: '',
        topRatio: 43.6,
        top: '43.6%',
        left: '14.7%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '12',
        textSelected: '',
        topRatio: 46.6,
        top: '46.6%',
        left: '17.8%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '13',
        textSelected: '',
        topRatio: 49.4,
        top: '49.4%',
        left: '21.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '14',
        textSelected: '',
        topRatio: 52.1,
        top: '52.1%',
        left: '24.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '15',
        textSelected: '',
        topRatio: 55.1,
        top: '55.1%',
        left: '29.8%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '16',
        textSelected: '',
        topRatio: 57.1,
        top: '57.1%',
        left: '34.3%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '17',
        textSelected: '',
        topRatio: 58.8,
        top: '58.8%',
        left: '39%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '18',
        textSelected: '',
        topRatio: 60.5,
        top: '60.5%',
        left: '43%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '19',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '53.6%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-100%',
        selRight: 'initial'
      }, {
        text: '20',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '56.8%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-80%',
        selRight: 'initial'
      }, {
        text: '21',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '60%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-60%',
        selRight: 'initial'
      }, {
        text: '22',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '63%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-40%',
        selRight: 'initial'
      }, {
        text: '23',
        textSelected: '',
        topRatio: 62.6,
        top: '62.6%',
        left: '66.2%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-20%',
        selRight: 'initial'
      }, {
        text: '24',
        textSelected: '',
        topRatio: 62.4,
        top: '62.4%',
        left: '69.4%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '0%',
        selRight: 'initial'
      }, {
        text: '25',
        textSelected: '',
        topRatio: 62,
        top: '62%',
        left: '72.6%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-20%',
        selRight: 'initial'
      }, {
        text: '26',
        textSelected: '',
        topRatio: 62,
        top: '62%',
        left: '76.2%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-10%',
        selRight: 'initial'
      }, {
        text: '27',
        textSelected: '',
        topRatio: 62.6,
        top: '62.6%',
        left: '80.8%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '0%',
        selRight: 'initial'
      }, {
        text: '28',
        textSelected: '',
        topRatio: 63.6,
        top: '63.6%',
        left: '84.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '29',
        textSelected: '',
        topRatio: 61.1,
        top: '61.1%',
        left: '89.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '30',
        textSelected: '',
        topRatio: 53.6,
        top: '53.6%',
        left: '90.9%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '31',
        textSelected: '',
        topRatio: 48,
        top: '48%',
        left: '88.8%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '32',
        textSelected: '',
        topRatio: 43.3,
        top: '43.3%',
        left: '86.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '33',
        textSelected: '',
        topRatio: 38.9,
        top: '38.9%',
        left: '83.8%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '34',
        textSelected: '',
        topRatio: 34.2,
        top: '34.2%',
        left: '81%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '35',
        textSelected: '',
        topRatio: 30.2,
        top: '30.2%',
        left: '78.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '36',
        textSelected: '',
        topRatio: 26.8,
        top: '26.8%',
        left: '76.1%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '37',
        textSelected: '',
        topRatio: 23.2,
        top: '23.2%',
        left: '74.1%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '38',
        textSelected: '',
        topRatio: 19.4,
        top: '19.4%',
        left: '71.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '39',
        textSelected: '',
        topRatio: 16,
        top: '16%',
        left: '69%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '40',
        textSelected: '',
        topRatio: 13,
        top: '13%',
        left: '66.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '41',
        textSelected: '',
        topRatio: 11,
        top: '11%',
        left: '62.2%',
        state: 0,
        selTop: 'initial',
        selBottom: '100%',
        selLeft: '0%',
        selRight: 'initial'
      }, {
        text: '42',
        textSelected: '',
        topRatio: 11,
        top: '11%',
        left: '57.8%',
        state: 0,
        selTop: 'initial',
        selBottom: '100%',
        selLeft: '0%',
        selRight: 'initial'
      }],
      markerDisabledList: [],
      items: [],
      names: [
        'name',
        'leader',
        'members',
        'memberNames',
        'kcbsNumber',
        'address', 'address2', 'city', 'state', 'zip', 'county',
        'email',
        'phone', 'phone2',
        'sellBbq',
        'bbq',
        'power',
        'labelCheck', // label
        'competition2',
        'competition',
        'labelTopNote',
        'labelCompetition',
        'topDesiredLocation', 'topMap',
        'top1', 'top2', 'top3', 'top4', 'top5',
        'volunteer',
        'labelVolunteer',
        // 'labelVolunteerYes',
        'tshirt', 'tshirtS', 'tshirtM', 'tshirtL', 'tshirtXL', 'tshirt2XL', 'tshirt3XL',
        'freeStrawberry', 'freeKingOfWing',
        'labelAmount', // label
        'amount',
        'labelAmountTerm', // label
        'labelTerm', // label
        'signature', 'signAt', 'signNote'
      ],
      models: {
        recaptcha: undefined,
        name: '',
        leader: '',
        members: '',
        memberNames: '',
        kcbsNumber: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        email: '',
        phone: '',
        phone2: '',
        // sellBbq: undefined,
        bbq: undefined,
        power: undefined,
        volunteer: 0,
        competition: 0,
        competition2: 0,
        // topDesiredLocation: [],
        top1: '',
        top2: '',
        top3: '',
        top4: '',
        top5: '',
        tshirt: undefined,
        tshirtS: '',
        tshirtM: '',
        tshirtL: '',
        tshirtXL: '',
        tshirt2XL: '',
        tshirt3XL: '',
        freeStrawberry: false,
        freeKingOfWing: false,
        // labelAmount: '',
        amount: '0',
        // labelAmountTerm: '',
        // labelTerm: '',
        signature: '',
        signAt: '',
        signNote: undefined
      },
      // models: {
      //   recaptcha: undefined,
      //   name: 'team1',
      //   leader: 'leader1',
      //   members: '11',
      //   address: 'address1',
      //   address2: 'address2',
      //   city: 'city1',
      //   state: 'state1',
      //   zip: '12345',
      //   county: 'county1',
      //   email: 'email@gmail.com',
      //   phone: 'phone1',
      //   phone2: 'phone2',
      //   // sellBbq: undefined,
      //   bbq: 1,
      //   power: 2,
      //   competition: 1,
      //   competition2: false,
      //   // topDesiredLocation: [],
      //   top1: '5',
      //   top2: '4',
      //   top3: '3',
      //   top4: '2',
      //   top5: '1',
      //   tshirt: true,
      //   tshirtS: '1',
      //   tshirtM: '2',
      //   tshirtL: '3',
      //   tshirtXL: '4',
      //   tshirt2XL: '5',
      //   tshirt3XL: '6',
      //   freeStrawberry: true,
      //   freeKingOfWing: true,
      //   // labelAmount: [],
      //   amount: '0',
      //   // labelTerm: [],
      //   signature: 'leader1',
      //   signAt: 'date1'
      // },
      attributes: {
        name: {
          title: 'Team Name',
          column: 'is-6'
        },
        leader: {
          title: 'Team Leader',
          column: 'is-6'
        },
        members: {
          // type: 'dropdown',
          title: 'Number of Team Members',
          // options: [
          //   { value: undefined,
          //     title: 'Number of Team Members' },
          //   { value: 1, title: '1' },
          //   { value: 2, title: '2' },
          //   { value: 3, title: '3' },
          //   { value: 4, title: '4' },
          //   { value: 5, title: '5' },
          //   { value: 6, title: '6' },
          //   { value: 7, title: '7' },
          //   { value: 8, title: '8' },
          //   { value: 9, title: '9' }
          // ],
          note: '* Please include $10 per team member in excess of four (include Team Leader in this count). Team wristbands will be distributed on site before gates open.'
        },
        memberNames: {
          title: 'Team Member Names',
          note: '* Please fill in the names separated by commas, including the Team Leader’s Name.'
        },
        kcbsNumber: {
          title: 'KCBS Team Number'
        },
        email: {
          title: 'Email'
        },
        // address: {
        //   type: 'textarea',
        //   title: 'Address',
        //   curLength: 0,
        //   maxLength: 500
        // },
        address: {
          title: 'Address 1'
        },
        address2: {
          title: 'Address 2'
        },
        city: {
          title: 'City',
          column: 'is-6'
        },
        state: {
          title: 'State',
          column: 'is-6'
        },
        zip: {
          title: 'Zip Code',
          column: 'is-6'
        },
        county: {
          title: 'County',
          column: 'is-6'
        },
        phone: {
          title: 'Primary Phone',
          column: 'is-6'
        },
        phone2: {
          title: 'Secondary Phone',
          column: 'is-6'
        },
        // sellBbq: {
        //   type: 'dropdown',
        //   title: 'Sell BBQ',
        //   options: [{
        //     value: undefined,
        //     title: 'Do you plan on selling BBQ? It\'s FREE y\'all!'
        //   }, {
        //     value: 1,
        //     title: 'YES'
        //   }, {
        //     value: 2,
        //     title: 'NO'
        //   }]
        // },
        bbq: {
          type: 'radio',
          title: 'Do you plan on selling BBQ? It\'s FREE y\'all! (If you sell BBQ, you keep all of the money!)',
          options: [{
            value: 1,
            title: 'YES'
          }, {
            value: 2,
            title: 'NO'
          }]
          // note: `* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application`,
          // noteStyle: {
          //   marginLeft: '24px'
          // }
        },
        power: {
          type: 'radio',
          title: 'Power (please specify)',
          options: [{
            value: 1,
            title: 'None'
          }, {
            value: 2,
            title: '20 amp 120 volt (Standard receptacle)'
          }, {
            value: 3,
            title: '30 amp 120 volt (RV receptacle)'
          }],
          onChecked: function (value) {
            console.log(value)
          }
        },
        labelCheck: {
          type: 'label',
          title: 'Check all that apply:'
        },
        competition2: {
          type: 'radio',
          title: 'Competition',
          options: [{
            value: 2,
            title: '$275 KCBS Competition Only'
          }]
          // note: `* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application`,
          // noteStyle: {
          //   marginLeft: '24px'
          // }
        },
        competition: {
          type: 'radio',
          title: 'Competition',
          titleHidden: true,
          options: [{
            value: 1,
            title: '$225 KCBS Competition & People\'s Choice Competition'
          }]
          // note: '<b>NEW:</b> you scratch our backs, we scratch yours &#9786; People\'s Choice Participants can now rank their <b>TOP 5</b> most desired site location numbers according to the Event Map below, & we will assure you get 1 of the 5:',
          // note: `* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application`,
          // noteStyle: {
          //   marginLeft: '24px'
          // }
        },
        labelTopNote: {
          type: 'label',
          column: 'is-10',
          // note: '<b>NOTE: There will be 1st & 2nd Places awarded to 2 Hometown Teams and 2 Out-of-Town Teams.</b><br />Ticket holders will get 4 voting chips, which must be used to vote for 2 different Hometown Teams and 2 different Out-of-Town Teams. The voting process will be strictly monitored. Which cash prizes will be awarded, this portion of the Cook-Off is intended to be a fun, casual time for sponsors, judges and general public to interact with team members. This contest is a huge draw for our community, and in order for The Boss to remain successful, we are asking for your support and participation! Click <a href="/schedule?anchor=peoples-choice-competition" style="text-decoration:underline;" target="_blank">here</a> for more details.'
          note: '<b>So how does People’s Choice Competition work?? There will be 1st, 2nd, & 3rd Places awarded to 3 Hometown Teams and 3 Out-of-Town Teams.</b><br />Ticket holders will get 6 voting chips, which must be used to vote for 3 different Hometown Teams and 3 different Out-of-Town Teams—the voting process will be strictly monitored. Cash prizes will be awarded. This portion of the Cook-Off is intended to be a fun, casual time for sponsors, judges and general public to interact with team members & sample some of the best BBQ around! This contest is a huge draw for our community, and in order for The Boss to remain successful, we are asking for your support and participation! Click <a href="/schedule?anchor=peoples-choice-competition" style="text-decoration:underline;" target="_blank">here</a> for more details.'
        },
        labelCompetition: {
          type: 'label',
          note: 'As a THANK YOU, <b>People\'s Choice Participants can now rank their TOP 5 most desired site location numbers</b> according to the Event Map below, & we will assure you get 1 of the 5 (* must choose 3 from one side of the field & 2 from the other side [left side is 1-18 & right side is 19-42] AND must list all 5 locations to receive this perk!)',
          noteStyle: {
            fontSize: '0.9em'
          }
        },
        topDesiredLocation: {
          type: 'label',
          title: 'Top 5 Desired Site Location (Available for People\'s Choice Participants Only!)',
          column: 'is-10'
        },
        topMap: {
          type: 'image',
          link: imageMap,
          onClick: () => {
            this.onSelectMarkerAll()
          },
          title: '(click to select locations)',
          column: 'is-8'
        },
        top1: {
          title: '1st',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: (item, model) => {
            this.onSelectMarker(item)
          }
        },
        top2: {
          title: '2nd',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: (item, model) => {
            this.onSelectMarker(item)
          }
        },
        top3: {
          title: '3rd',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: (item, model) => {
            this.onSelectMarker(item)
          }
        },
        top4: {
          title: '4th',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: (item, model) => {
            this.onSelectMarker(item)
          }
        },
        top5: {
          title: '5th',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: (item, model) => {
            this.onSelectMarker(item)
          }
          // note: '<b>NOTE: There will be 1st & 2nd Places awarded to 2 Hometown Teams and 2 Out-of-Town Teams.</b><br />Ticket holders will get 4 voting chips, which must be used to vote for 2 different Hometown Teams and 2 different Out-of-Town Teams. The voting process will be strictly monitored. Which cash prizes will be awarded, this portion of the Cook-Off is intended to be a fun, casual time for sponsors, judges and general public to interact with team members. This contest is a huge draw for our community, and in order for The Boss to remain successful, we are asking for your support and participation! See the details below.'
        },
        volunteer: {
          disabled: true,
          column: 'is-10',
          type: 'radio',
          title: 'Volunteer * for People’s Choice Competition (Saturday, 11AM-2PM)',
          options: [{
            value: 1,
            title: 'Yes, I want a volunteer.'
          }, {
            value: 2,
            title: 'No, I want to provide my own volunteer.'
          }]
        },
        labelVolunteer: {
          type: 'label',
          column: 'is-10',
          // note: '<b>NOTE:</b> If participating in the People’s Choice Competition, D.O.O.R. will provide a volunteer & paper goods to distribute to the public throughout the tasting and voting times.  However, if you have a team member who would like to do this please indicate below. *'
          note: '<b>NOTE:</b> If participating in People’s Choice Competition, D.O.O.R. will provide paper goods & a volunteer (*IF indicated above) to distribute samples to the public during the tasting/voting times (11AM-2PM).  IF you have a Team Member who is able to do this then please indicate by choosing “No, I want to provide my own volunteer.”<br /><br />If you choose “Yes, I want a volunteer.” then you must provide shade for the volunteer (i.e., tent, canopy, etc.).  All participating teams must provide their own table.'
        },
        // labelVolunteerYes: {
        //   type: 'label',
        //   column: 'is-10',
        //   note: '<b>NOTE:</b> If you select Yes I would like a volunteer, you must provide a table and shade for the volunteer. *'
        // },
        tshirt: {
          type: 'radio',
          title: 'T-Shirt Pre Order',
          options: [{
            value: 1,
            title: 'YES'
          }, {
            value: 2,
            title: 'NO'
          }],
          // withDefault: true,
          note: '$12 per shirt, please list the quantity next to the sizes below (2XL and 3XL are preorder only & have the following upcharges: 2XL+$2.00 and 3XL+$3.00).'
        },
        tshirtS: {
          title: 'S',
          column: 'is-5',
          disabled: true
        },
        tshirtM: {
          title: 'M',
          column: 'is-5',
          disabled: true
        },
        tshirtL: {
          title: 'L',
          column: 'is-5',
          disabled: true
        },
        tshirtXL: {
          title: 'XL',
          column: 'is-5',
          disabled: true
        },
        tshirt2XL: {
          title: '2XL',
          column: 'is-5',
          disabled: true
        },
        tshirt3XL: {
          title: '3XL',
          column: 'is-5',
          disabled: true
        },
        freeStrawberry: {
          type: 'checkbox',
          title: 'FREE Anything Strawberry Competition',
          options: [],
          withDefault: true,
          note: `$600 purse! See <a href="/schedule?anchor=anything-strawberry-competition" target="_blank" style="border-bottom:1px solid black;">Events & Schedule</a> for more details.<br />`
          // `<div style="margin-top:6px;">* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application</div>`
        },
        freeKingOfWing: {
          type: 'checkbox',
          title: 'FREE King of the Wing Competition (wings provided)',
          options: [],
          withDefault: true,
          note: `$1000 purse! See <a href="/schedule?anchor=king-of-the-wing" target="_blank" style="border-bottom:1px solid black;">Events & Schedule</a> for more details.<br />Participating teams will receive a custom Boss Hog Cook-Off gift in an effort to encourage team participation.<br />This Competition entertains our largest sponsorship level, so the more participants the better.<br />`
          // `<div style="margin-top:6px;">* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application</div>`
        },
        labelAmount: {
          type: 'label',
          title: 'Total Amount Due:'
        },
        amount: {
          title: 'Amount',
          disabled: true,
          column: 'is-4'
        },
        labelAmountTerm: {
          type: 'label',
          note: `<p><b>Note:</b> Your online team application submission does NOT guarantee your selection and/or placement for the ${EventBus.info.xth} Annual Boss Hog Cook-Off.  The BOSS must receive your payment in order to be entered into the ${EventBus.info.year} competition.</p>` +
          '<p style="margin-top:5px;margin-bottom:5px;">Once your payment has been received, you will be notified by the BOSS to confirm your entry.  Email confirmation for the application submission will be sent upon completion.</p>' +
          '<p style="margin-top:5px;margin-bottom:5px;">TWO Payment Options Available: VENMO & CHECK.</p>' +
          '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;">PAY BY VENMO:</p>' +
          '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;"><ul style="display:block;margin:0;margin-left:60px;"><li>please add a $6 convenience fee to your total and send to @DOORwaynesboroGA</li></ul></p>' +
          '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;">PAY BY CHECK:</p>' +
          '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;"><ul style="display:block;margin:0;margin-left:60px;"><li>Make checks payable to D.O.O.R.</li><li>Mail your check to:</br>D.O.O.R.</br>ATTN: Nan Lynch & Lindsey Beazley Keller</br>P.O. Box 647</br>Waynesboro, GA 30830.</li></ul></p>'
        },
        labelTerm: {
          type: 'label',
          note: '<b>Conditions:</b> The Boss Hog Cook-Off Committee reserves the right to reject any application. If your application is not accepted, your money will be refunded. However, no refunds of the application fee will be made once you have been accepted into the contest. Any photographs or videos taken of your team on-site become the property of D.O.O.R. and may be used for promotional purposes. ' +
          'By signing the application, contestants agree to indemnify and hold D.O.O.R., the Boss Hog Committee, the City of Waynesboro, Mr. Golf Carts Inc., and all employees, agents and volunteers, harmless from any and all claims made against same; including without limitation, all costs, liabilities, judgments, expenses, damages or reasonable attorneys’ fees, arising out of, or in connection with; (1) any structure erected by Contestant; (2) any apparatus, equipment or personal property used by Contestant; (3) any act or omission to act of Contestant, its agents, invitees, participants, representatives, employees, servants, and assigns; and (4) any claims made on account or resulting from contestants participating in the contest.<br />' +
          '<b>Participant’s Agreement:</b> The undersigned agrees that he/she will be responsible for any loss or damage to his/her work during Boss Hog. He/She agrees to abide by all rules as set forth by Boss Hog and <a href="static/rules.pdf" target="_blank"><b>KCBS</b></a>. My signature below and enclosed amount due/mailed payment indicate that I understand that failure to abide by these rules and regulations may result in the termination of my contract and my participation in future events with D.O.O.R. This is a rain or shine festival, and no refund will be given due to weather.<br />' +
          '<b>Parking Agreement:</b> ONLY ONE VEHICLE ALLOWED PER TEAM COOK SITE.  Due to the overwhelming growth of our event, we need as much parking for patrons as possible.  Therefore, any vehicle OR trailer in excess of ONE must park in the designated area.  Parking Passes will be given for the team vehicles to be placed in the front window – towing will be enforced at the owner’s expense.  Thank you for understanding!'
          // `<div style="margin-top:12px;"><a href="/static/kcbs_covid-19_regulations.pdf" target="_blank" style="font-weight:bold;"><i class="fa fa-file-o" style="font-size:1.5em;"></i>&nbsp;&nbsp;EMERGENCY ADDENDUM TO KCBS SANCTIONING AGREEMENT.PDF</a></div>`
        },
        signature: {
          title: 'Team Leader\'s Name',
          column: 'is-6'
          // note: '* By typing your name, you agree to the above.<br />' +
          // `* By typing your name and submitting this Team A pplication, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations stated in the “Emergency Addendum to KCBS Sanctioning Agreement” attached above.`
        },
        signAt: {
          title: 'Date',
          column: 'is-6',
          disabled: true
        },
        signNote: {
          null: true,
          title: 'Note',
          column: 'is-12',
          note: '* By typing your name, you agree to the above.<br />' +
          `* By typing your name and submitting this Team Application, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations enforced locally as well as any KCBS guidelines/addendums that may arise.`
        }
      },
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      loading: false,
      navEmail: EventBus._data._navEmail
    }
  },
  validations: {
    models: {
      recaptcha: { required },
      name: { required },
      leader: { required },
      members: { required, numeric, between: between(1, 100) },
      memberNames: { required },
      kcbsNumber: {},
      // address: { required, maxLength: maxLength(500) },
      address: { required, maxLength: maxLength(500) },
      address2: { maxLength: maxLength(500) },
      city: { required, maxLength: maxLength(191) },
      state: { required, maxLength: maxLength(191) },
      zip: { required, maxLength: maxLength(191) },
      county: { required },
      email: { required, email, minLength: minLength(4) },
      phone: { required },
      phone2: {},
      // sellBbq: { required },
      bbq: { required },
      power: {
        required
        // required_custom: validateArrayRequired,
        // either_custom: validateArrayOneNoneOrTwoThreeFour
      },
      labelCheck: {}, // label
      labelVolunteer: {},
      volunteer: {
        required_custom: function (value) {
          if (this.models.competition === undefined || this.models.competition === false) {
            return true
          }
          return (this.models.volunteer !== undefined && this.models.volunteer !== 0)
        }
      },
      // labelVolunteerYes: {},
      competition: {
        required_custom: function (value) {
          return validateEitherOr(value, this.models.competition2)
        }
      },
      labelCompetition: {},
      competition2: {
        required_custom: function (value) {
          return validateEitherOr(value, this.models.competition)
        }
      },
      topDesiredLocation: {},
      topMap: {},
      top1: { numeric,
        between: between(1, 42),
        either_custom: function (value) {
          return validateUnique(
            value,
            this.models.top2,
            this.models.top3,
            this.models.top4,
            this.models.top5)
        }
      },
      top2: { numeric,
        between: between(1, 42),
        either_custom: function (value) {
          return validateUnique(
            value,
            this.models.top1,
            this.models.top3,
            this.models.top4,
            this.models.top5)
        }
      },
      top3: { numeric,
        between: between(1, 42),
        either_custom: function (value) {
          return validateUnique(
            value,
            this.models.top1,
            this.models.top2,
            this.models.top4,
            this.models.top5)
        }
      },
      top4: { numeric,
        between: between(1, 42),
        either_custom: function (value) {
          return validateUnique(
            value,
            this.models.top1,
            this.models.top2,
            this.models.top3,
            this.models.top5)
        }
      },
      top5: { numeric,
        between: between(1, 42),
        either_custom: function (value) {
          return validateUnique(
            value,
            this.models.top1,
            this.models.top2,
            this.models.top3,
            this.models.top4)
        }
      },
      labelTopNote: {},
      tshirt: { required },
      tshirtS: { numeric,
        required_custom: function (value) {
          if (this.models.tshirt !== 1) {
            return true
          }
          var tshirts = addAllValues(this.models.tshirtS,
            this.models.tshirtM,
            this.models.tshirtL,
            this.models.tshirtXL,
            this.models.tshirt2XL,
            this.models.tshirt3XL)
          console.log('total: ' + tshirts)
          if (tshirts > 0) {
            return true
          }
          return false
        }
      },
      tshirtM: { numeric,
        required_custom: function (value) {
          if (this.models.tshirt !== 1) {
            return true
          }
          var tshirts = addAllValues(this.models.tshirtS,
            this.models.tshirtM,
            this.models.tshirtL,
            this.models.tshirtXL,
            this.models.tshirt2XL,
            this.models.tshirt3XL)
          return (tshirts > 0)
        }
      },
      tshirtL: { numeric,
        required_custom: function (value) {
          if (this.models.tshirt !== 1) {
            return true
          }
          var tshirts = addAllValues(this.models.tshirtS,
            this.models.tshirtM,
            this.models.tshirtL,
            this.models.tshirtXL,
            this.models.tshirt2XL,
            this.models.tshirt3XL)
          return (tshirts > 0)
        }
      },
      tshirtXL: { numeric,
        required_custom: function (value) {
          if (this.models.tshirt !== 1) {
            return true
          }
          var tshirts = addAllValues(this.models.tshirtS,
            this.models.tshirtM,
            this.models.tshirtL,
            this.models.tshirtXL,
            this.models.tshirt2XL,
            this.models.tshirt3XL)
          return (tshirts > 0)
        }
      },
      tshirt2XL: { numeric,
        required_custom: function (value) {
          if (this.models.tshirt !== 1) {
            return true
          }
          var tshirts = addAllValues(this.models.tshirtS,
            this.models.tshirtM,
            this.models.tshirtL,
            this.models.tshirtXL,
            this.models.tshirt2XL,
            this.models.tshirt3XL)
          return (tshirts > 0)
        }
      },
      tshirt3XL: { numeric,
        required_custom: function (value) {
          if (this.models.tshirt !== 1) {
            return true
          }
          var tshirts = addAllValues(this.models.tshirtS,
            this.models.tshirtM,
            this.models.tshirtL,
            this.models.tshirtXL,
            this.models.tshirt2XL,
            this.models.tshirt3XL)
          return (tshirts > 0)
        }
      },
      freeStrawberry: {},
      freeKingOfWing: {},
      labelAmount: {}, // label
      amount: {},
      labelAmountTerm: {}, // label
      labelTerm: {}, // label
      signature: { required },
      signAt: { required },
      signNote: {}
    }
  },
  created: function () {
    // console.log('-- creating... --')
    // console.log(this.$v)
    // console.log(this.models)
    // this.init()
  },
  mounted: function () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.onUpdateMap(EventBus._windowWidth)
    EventBus.$on('windowWidthChanged', function () {
      this.onUpdateMap(EventBus._windowWidth)
    }.bind(this))

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    if (this.isPrint) {
      this.attributes.topMap.column = 'is-10'
    } else {
      this.attributes.topMap.column = 'is-8'
    }

    if (this.isPrint) {
      this.models.signAt = ''
    } else {
      this.models.signAt = (moment(new Date())).format()
    }

    // console.log('-- mounting... --')
    // console.log(this.$v)
    this.onLoad()
  },
  methods: {
    onLoad: function () {
      this.markerDisabledList = []
      Site.signUpApproved(
      ).then(data => {
        // console.log('-- approved')
        // console.log(data)
        for (var i in this.markerList) {
          var marker = this.markerList[i]
          let locationIndex = parseInt(marker.text, 10)
          // 0 = disabled
          // 1 = enabled
          // 2 = selected
          marker.state = 1 // all enabled

          var state = 1
          var approved = _.find(data, { admin_location: locationIndex })
          if (approved && typeof approved === 'object') {
            state = 0
          }
          this.markerDisabledList.push({
            text: marker.text,
            state
          })
        }
        this.onUpdateMapMarkers()
      }).catch(error => {
        console.error(error)
      })
    },

    onUpdateMapMarkers: function () {
      for (var i in this.markerList) {
        var marker = this.markerList[i]
        var state = 0 // disabled
        var markerDisabled = _.find(this.markerDisabledList, { text: marker.text })
        // console.log(markerDisabled)
        if (markerDisabled && markerDisabled.hasOwnProperty('state')) {
          state = markerDisabled.state
        }
        marker.textSelected = ''
        let spots = ['top1', 'top2', 'top3', 'top4', 'top5']
        for (var s in spots) {
          let spot = spots[s]
          if (this.models[spot] + '' === marker.text) {
            state = 2 // selected
            marker.textSelected = '(' + this.attributes[spot].title + ' location)'
          }
        }
        marker.state = state
      }
    },

    onUpdateMap: function (windowWidth) {
      for (var i in this.markerList) {
        var marker = this.markerList[i]
        if (windowWidth > 1024) {
          marker.top = marker.topRatio * 720 / 100 + 27 + 'px'
          this.markerHeight = 4 * 720 / 100 + 'px'
        } else {
          if (this.$refs.mapRef) {
            // console.log(this.$refs.mapRef.width + ', ' + this.$refs.mapRef.height)
            marker.top = marker.topRatio * this.$refs.mapRef.height / 100 + 27 + 'px'
            this.markerHeight = 4 * 720 / 100 + 'px'
          } else {
            marker.top = marker.topRatio + '%'
            this.markerHeight = '4%'
          }
        }
      }

      if (windowWidth > 1024) {
        this.markerClear.top = this.markerClear.topRatio * 720 / 100 + 'px'
      } else {
        if (this.$refs.mapRef) {
          this.markerClear.top = this.markerClear.topRatio * 720 / 100 + 'px'
        } else {
          this.markerClear.top = this.markerClear.topRatio + '%'
        }
      }
    },

    calculateTotal: function (competition, competition2, members, tshirtS, tshirtM, tshirtL, tshirtXL, tshirt2XL, tshirt3XL) {
      this.models.amount = 0
      if (competition) {
        this.models.amount += 225
      }
      if (competition2) {
        this.models.amount += 275
      }
      if (tshirtS > 0) {
        this.models.amount += tshirtS * 12
      }
      if (tshirtM > 0) {
        this.models.amount += tshirtM * 12
      }
      if (tshirtL > 0) {
        this.models.amount += tshirtL * 12
      }
      if (tshirtXL > 0) {
        this.models.amount += tshirtXL * 12
      }
      if (tshirt2XL > 0) {
        this.models.amount += tshirt2XL * (12 + 2)
      }
      if (tshirt3XL > 0) {
        this.models.amount += tshirt3XL * (12 + 3)
      }
      if (members && members.length > 0 && !isNaN(parseInt(members, 10))) {
        var total = parseInt(members, 10)
        if (total > 4) {
          this.models.amount += (total - 4) * 10
        }
      }
    },

    onRecaptcha: function (info) {
      if (info && info.status) {
        this.models.recaptcha = (info.status === 'ok' ? info.response : undefined)
        if (info.status !== 'ok') {
          console.log('FormDynamix:recaptcha():' + info.status)
        }
      }
    },

    onSelectMarkerAll: function () {
      if (this.models.competition !== 1) {
        return
      }
      this.markerCurrent = undefined
      this.isMapModalActive = true
      this.$nextTick(function () {
        // console.log('-- refs --')
        // console.log(this.$refs.mapRef)
        this.onUpdateMap(EventBus._windowWidth)
      })
    },

    onSelectMarker: function (item) {
      if (this.models.competition !== 1) {
        return
      }
      this.markerCurrent = item
      this.isMapModalActive = true
      this.$nextTick(function () {
        // console.log('-- refs --')
        // console.log(this.$refs.mapRef)
        this.onUpdateMap(EventBus._windowWidth)
      })
    },

    getAvailableSpot: function () {
      let spots = ['top1', 'top2', 'top3', 'top4', 'top5']
      for (var s in spots) {
        let spot = spots[s]
        // console.log('spot: ' + s + ', ' + this.models[spot] + ' = ' + this.models[spot].length)
        if (this.models[spot] === undefined || (typeof this.models[spot] === 'string' && this.models[spot].length <= 0)) {
          return spot
        }
      }
      return undefined
    },

    onResetMapMarker: function () {
      let spots = ['top1', 'top2', 'top3', 'top4', 'top5']
      for (var s in spots) {
        let spot = spots[s]
        this.models[spot] = ''
      }
      this.onUpdateMapMarkers()
    },

    onProceed: function () {
      this.markerCurrent = undefined
      this.isMapModalActive = false
      this.$nextTick(function () {
        this.onUpdateMap(EventBus._windowWidth)
      })
    },

    onClickMapMarker: function (marker) {
      // if (!this.markerCurrent) {
      //   console.error('something is wrong', marker)
      //   return
      // }

      if (marker.state !== 1) {
        // only can choose state enabled
        if (marker.state === 0) {
          this.$toast.open({
            duration: 2000,
            message: `Location not available.`,
            position: 'is-top',
            type: 'is-danger'
          })
        }
        return
      }

      if (!this.markerCurrent) {
        var spot = this.getAvailableSpot()
        if (!spot) {
          console.error('all 5 locations selected')
          this.$toast.open({
            duration: 2000,
            message: `All 5 locations selected, please kindly reset or proceed with the selections.`,
            position: 'is-top',
            type: 'is-warning'
          })
          return
        }

        this.models[spot] = marker.text
        this.onUpdateMapMarkers()
        return
      }

      // console.log('market text is: ' + marker.text)
      this.models[this.markerCurrent.name] = marker.text
      // this.isMapModalActive = false
      this.onUpdateMapMarkers()
    },

    onClear: function () {
      // this.models.recaptcha = undefined
      this.models.name = ''
      this.models.leader = ''
      this.models.members = ''
      this.models.memberNames = ''
      this.models.kcbsNumber = ''
      this.models.address = ''
      this.models.address2 = ''
      this.models.city = ''
      this.models.state = ''
      this.models.zip = ''
      this.models.county = ''
      this.models.email = ''
      this.models.phone = ''
      this.models.phone2 = ''
      // this.models.sellBbq = undefined
      this.models.bbq = undefined
      this.models.power = undefined
      this.models.volunteer = 0
      this.models.competition = 0
      this.models.competition2 = 0
      // this.models.topDesiredLocation = []
      this.models.top1 = ''
      this.models.top2 = ''
      this.models.top3 = ''
      this.models.top4 = ''
      this.models.top5 = ''
      this.models.tshirt = false
      this.models.tshirtS = ''
      this.models.tshirtM = ''
      this.models.tshirtL = ''
      this.models.tshirtXL = ''
      this.models.tshirt2XL = ''
      this.models.tshirt3XL = ''
      this.models.freeStrawberry = false
      this.models.freeKingOfWing = false
      // this.models.labelAmount = ''
      this.models.amount = '0'
      // this.models.labelAmountTerm = ''
      // this.models.labelTerm = ''
      this.models.signature = ''
      this.models.signAt = (moment(new Date())).format()
    },

    onSendDisabled: function () {
      var _self = this
      _self.feedback = 'We are sorry, team application is not open yet.'
      return
    },

    onSend: function (formInfo) {
      // $v.models.$touch()
      var _self = this
      console.log('SignUpTeamSection:onSend(): $v / models')
      console.log(formInfo)

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.'
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return
      }

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.'
        return
      }
      _self.feedback = false

      var models = formInfo.models

      // competition
      var competition = 0
      if (models.competition && !models.competition2) {
        competition = 1
      } else if (!models.competition && models.competition2) {
        competition = 2
      } else if (models.competition && models.competition2) {
        competition = -1
      }

      // locations
      var locations = []
      locations.push((models.top1 ? models.top1 : ''))
      locations.push((models.top2 ? models.top2 : ''))
      locations.push((models.top3 ? models.top3 : ''))
      locations.push((models.top4 ? models.top4 : ''))
      locations.push((models.top5 ? models.top5 : ''))

      // tshirts
      var tshirts = {}
      tshirts.s = models.tshirtS ? models.tshirtS : 0
      tshirts.m = models.tshirtM ? models.tshirtM : 0
      tshirts.l = models.tshirtL ? models.tshirtL : 0
      tshirts.xl = models.tshirtXL ? models.tshirtXL : 0
      tshirts.x2l = models.tshirt2XL ? models.tshirt2XL : 0
      tshirts.x3l = models.tshirt3XL ? models.tshirt3XL : 0

      console.log('-- send form --')
      console.log(models)
      // console.log(models.name)
      // console.log(models.leader)
      // console.log(models.members)
      // console.log(models.address)
      // console.log(models.address2)
      // console.log(models.city)
      // console.log(models.state)
      // console.log(models.zip)
      // console.log(models.county)
      // console.log(models.email)
      // console.log(models.phone)
      // console.log(models.phone2)
      // console.log(models.bbq)
      // console.log(models.power)
      // console.log(competition)
      // console.log(locations)
      // console.log(models.tshirt)
      // console.log(tshirts)
      // console.log(models.freeStrawberry)
      // console.log(models.freeKingOfWing)
      // console.log(models.signature)
      // console.log(models.signAt)
      // console.log(models.amount)

      // if (formInfo) {
      //   return
      // }

      _self.loading = true
      Site.signUpTeam(
        models.recaptcha,
        models.name,
        models.leader,
        models.members,
        models.memberNames,
        models.kcbsNumber,
        models.address,
        models.address2,
        models.city,
        models.state,
        models.zip,
        models.county,
        models.email,
        models.phone,
        models.phone2,
        models.bbq, // 1 = yes, 2 = no
        models.power, // 1 = none, 2 = 20 amp, 3 = 30 amp
        models.volunteer,
        competition, // 1 = kcbs & people's choice, 2 = kcbs
        locations, // 5 numerics
        models.tshirt,
        tshirts, // 6 types
        models.freeStrawberry,
        models.freeKingOfWing,
        models.signature,
        models.signAt,
        models.amount
      )
      .then(data => {
        _self.loading = false

        // invalid captcha
        if (data && data.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.'
          return
        }

        // invalid captcha
        if (data && data.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please re-type again.'
          return
        }

        if (data && data.status !== 'ok') {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
          return
        }

        this.$v.models.$reset()
        this.onClear()

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        // _self.$toast.open({
        //   message: 'We will be contacting you via email or phone. Thanks!',
        //   position: 'is-bottom',
        //   type: 'is-success'
        // })
        _self.feedback = 'Your application has been successfully submitted. You will receive a confirmation email within the next 48 hours.'
      })
      .catch(error => {
        console.log('invalid email', error)
        // this.error = error.error
        console.log(error)
        // _self.captcha = ''

        // invalid captcha
        if (error && error.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.'
          _self.loading = false
          return
        }

        // invalid captcha
        if (error && error.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please retype again.'
          _self.loading = false
          return
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
        _self.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-sign-up-team {
  // padding: 1rem 0;
  // margin-top: 4em;
  // margin-bottom: 2em;
  padding: 1rem 0.75rem;
  // -webkit-print-color-adjust: exact;

  .modal-wrapper {
    .modal-content, .modal-card {
      width: 100%;
      p {
        margin-bottom: 0;
        padding-bottom: 0;
      }

      max-height: calc(100vh - 20px);
      @media screen and (min-width: $desktop) {
        max-height: calc(100vh);
      }
    }

    @media screen and (min-width: $tablet) {
      .modal-content, .modal-card {
        width: 100%;
      }
    }

    @media screen and (min-width: $desktop) {
      .modal-content, .modal-card {
        width: 1000px;
      }
    }

    .marker {
      position: absolute;
      width: 3%;

      &.static {
        position: relative;
        width: auto;
      }
      // height: 4%;
      text-align: center;
      font-size: 100%;
      background-color: rgba(255,255,255,0);
      border: 1px dotted white;
      border-radius: 5px;
      cursor: pointer;
      padding-top: 3px;
      box-shadow: 1px 1px 2px 1px #000000;

      &.disabled {
        background-color: rgba(255,0,0,0.5);
      }

      &.enabled {
        background-color: rgba(0,255,0,0.5);
      }

      &.selected {
        background-color: rgba(255,218,0,0.8);
      }

      &:hover {
        border: 1px solid white;

        &.disabled {
          border: 1px dotted white;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// SignUpTeamSection.vue?5d1fb0ed